import { queryOptions } from '@tanstack/react-query';
import { QueryKeys } from 'utils/queryKeys';
import { DocumentServiceFoldersRepository } from 'services/folders/DocumentServiceFoldersRepository';
import type { ContentFolderType } from './entities';

const listFolders = (type: ContentFolderType) =>
  queryOptions({
    queryKey: QueryKeys.foldersTree(type),
    queryFn: async () => {
      return DocumentServiceFoldersRepository.listFolders({ type });
    },
  });

export const folderQueries = {
  listFolders,
};
